import { Component, Input } from '@angular/core';
import { EIconPath } from '../../../../../../../shared/enums/icons.enum';
import { TActivityChange } from '../../activity-change.model';

@Component({
    selector: 'pp-dashlet-activity-description-rich',
    templateUrl: './dashlet-activity-description-rich.component.html',
    styleUrls: ['../../dashlet-activity.component.scss'],
    standalone: false
})
export class DashletActivityDescriptionRichComponent {
  @Input() ppChange: TActivityChange<string>;

  EIconPath = EIconPath;
}
